interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  disabled?: boolean;
  onChange: (page: number) => void;
}

/** Footer pager shared by the list pages. Renders nothing for a single page. */
export function Pagination({
  page,
  totalPages,
  total,
  pageSize,
  disabled = false,
  onChange,
}: PaginationProps) {
  // A URL `?page=` can outrun the results (search narrowed, rows deleted):
  // show and step from the nearest real page rather than a nonsense range.
  const last = Math.max(1, totalPages);
  const current = Math.min(Math.max(1, page), last);
  if (last <= 1) return null;
  return (
    <div className="flex shrink-0 items-center justify-between border-t border-line bg-surface-2 px-4 py-2">
      <span className="text-xs tabular-nums text-muted">
        {((current - 1) * pageSize + 1).toLocaleString()}–
        {Math.min(current * pageSize, total).toLocaleString()} of{' '}
        {total.toLocaleString()}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          onClick={() => onChange(current - 1)}
          disabled={current <= 1 || disabled}
        >
          ‹ Prev
        </button>
        <span className="px-2 text-xs tabular-nums text-muted">
          {current} / {last}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          onClick={() => onChange(current + 1)}
          disabled={current >= last || disabled}
        >
          Next ›
        </button>
      </div>
    </div>
  );
}
